import clsx from "clsx";
import type { ReactNode } from "react";

export type PaywallModalShellProps = {
  open?: boolean;
  testId: string;
  title: string;
  children: ReactNode;
};

export function PaywallModalShell({ open = true, testId, title, children }: PaywallModalShellProps) {
  if (!open) {
    return null;
  }

  const titleId = `${testId}-title`;

  return (
    <div className="relative z-50">
      <div className="fixed-above-bottom-tab-bar z-[45] bg-black/[0.12] backdrop-blur-[2px]" aria-hidden />
      <div className="fixed-above-bottom-tab-bar z-50 flex max-h-full items-center justify-center overflow-y-auto p-4 pb-6">
        <div
          role="dialog"
          aria-labelledby={titleId}
          aria-modal="false"
          className={clsx(
            "w-full max-w-md border-card rounded-card bg-card section-padding",
            "max-h-[min(85vh,calc(100dvh-var(--height-bottom-tab-bar)-env(safe-area-inset-bottom,0px)-2rem))] overflow-y-auto"
          )}
          data-testid={testId}
        >
          <h2
            id={titleId}
            className="text-center font-mono text-[length:var(--font-size-headline-small)] font-semibold text-[#15161E]"
          >
            {title}
          </h2>
          {children}
        </div>
      </div>
    </div>
  );
}
